export const isEmpty = (value) => {
  return (
    value === undefined ||
    value === null ||
    (typeof value === "object" && Object.keys(value).length === 0) ||
    (typeof value === "string" && value.trim().length === 0)
  );
};
export const linkReplaceFn = (text) => {
  let text1 = text;
  let result = isEmpty(text1)
    ? ""
    : text1.replace(
        /src="ckfinder\//gi,
        'src="http://quizmaster.motion.ac.in/ckfinder/'
      );
  return result;
};
export const customSort = ({ data, sortBy, sortField }) => {
  const sortByObject = sortBy.reduce((obj, item, index) => {
    return {
      ...obj,
      [item]: index,
    };
  }, {});
  return data.sort(
    (a, b) => sortByObject[a[sortField]] - sortByObject[b[sortField]]
  );
};
export const couterArrayFn = (num) => {
    return Array.from({ length: num }, (_, index) => index + 1);
  };

// Example : const tasks = [
//   { id: 1, title: "Job A", status: "done" },
//   { id: 2, title: "Job B", status: "inProgress" },
//   { id: 3, title: "Job C", status: "todo" },
//   { id: 4, title: "Job D", status: "inProgress" },
//   { id: 5, title: "Job E", status: "todo" },
// ];
// const sortBy = ["inProgress", "todo", "done"];
// customSort({ data: tasks, sortBy, sortField: "status" })
